import React from 'react';
import t from '~t';
import { useSelector, useDispatch } from 'react-redux';
import { set } from '~data/actions/config';
import config from '~config';

import { Label, Select } from '~ui';

export default function SettingsAppBrokenLevel() {
  const broken_level = useSelector((state) => state.config.broken_level);
  const dispatch = useDispatch();

  return (
    <>
      <Label>
        {t.s('brokenLinks')}&nbsp;
        <a
          href={config.links.help.troubleshooting.brokenLinks.modes}
          target='_blank'
        >
          [?]
        </a>
      </Label>
      <div>
        <Select
          value={broken_level}
          onChange={(e) => dispatch(set('broken_level', e.target.value))}
        >
          {[
            ['basic', 'Basic mode'],
            ['default', 'Default mode'],
            ['strict', 'Strict mode'],
            ['off', t.s('disable')],
          ].map(([key, label]) => (
            <option key={key} value={key}>
              {label}
            </option>
          ))}
        </Select>
      </div>
    </>
  );
}
